/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ApiProjectSubscriptionPaymentFromJSON(json) {
    return ApiProjectSubscriptionPaymentFromJSONTyped(json, false);
}
export function ApiProjectSubscriptionPaymentFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'paidAt': !exists(json, 'paidAt') ? undefined : (new Date(json['paidAt'])),
    };
}
export function ApiProjectSubscriptionPaymentToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'amount': value.amount,
        'paidAt': value.paidAt === undefined ? undefined : (value.paidAt.toISOString()),
    };
}
